import { CopyId } from './CopyId.tsx'
import { shortId, type ShortIdKeep } from './shortId.ts'

export interface ShortIdProps {
  value: string
  /** 보이는 글자 수. 기본 8 */
  len?: number
  /** 남기는 쪽. 기본 `'head'`(앞 N자 + 「…」). 끝의 일련번호가 가르는 값은 `'tail'`(「…」 + 뒤 N자) — `shortId.ts` */
  keep?: ShortIdKeep | undefined
  className?: string
  /**
   * 원값을 클립보드에 넣는 버튼을 같이 세운다. **기본은 꺼짐**이다.
   *
   * 🔴 **목록의 행마다 켜지 마라**(eric·팀장 확정 2026-09-22). 행이 100줄이면 버튼도 100개라
   *    표가 시끄러워지고, 그 표에서 사람이 하는 일은 「고르기」이지 「복사」가 아니다.
   *    켜는 자리는 **작업 줄과 상세 제목** — 지금 보고 있는 것 하나를 가리키는 곳이다.
   */
  copy?: boolean | undefined
}

/**
 * 짧게 보이는 식별자.
 *
 * 🔴 **전체 값은 손실되지 않는다** — `title`(툴팁)과 `.a-sr`(보조기술) 양쪽으로 원값이 그대로
 *    나간다. 복사·검색·스크린리더가 짧은 값만 만나면 안 된다.
 * 🔴 고정폭(`mono`)이 기본이다 — 식별자와 시각에만 고정폭을 쓴다(방안 A).
 */
export function ShortId({ value, len, keep, className, copy = false }: ShortIdProps) {
  const text = (
    <span className={className === undefined ? 'mono' : `mono ${className}`} title={value}>
      <span aria-hidden="true">{shortId(value, len, keep)}</span>
      <span className="a-sr">{value}</span>
    </span>
  )

  if (!copy) return text

  /* ⚠ 복사 버튼을 «글자 안»에 넣지 않는다 — `title` 툴팁과 버튼 라벨이 겹쳐 읽힌다 */
  return (
    <span className="idrow">
      {text}
      <CopyId value={value} />
    </span>
  )
}
